// extracted by mini-css-extract-plugin
export default {"changelog":"Changelog_changelog__lEym7"};